export const GET_BIOMETRIC_LOGS = 'GET_BIOMETRIC_LOGS'
